import React, { FC, useContext } from 'react';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import NolNoticeBottomSheet from '../NolNoticeBottomSheet';

interface TopingMemberShipBottomSheetProps {}

const TopingMemberShipBottomSheet: FC<TopingMemberShipBottomSheetProps> = () => {
  const store = useContext(NolPromotionStoreCtx);
  return (
    <NolNoticeBottomSheet
      title={'토핑 멤버십 유의사항'}
      isOpen={store.isTopingMemberShipBottomSheetOpen}
      onRequestClose={() => (store.isTopingMemberShipBottomSheetOpen = false)}
    >
      <strong>※ 이벤트 기간: {store.eventNolCouponPeriod}</strong>
      <ul>
        <li>
          대상 : NOL 카드 보유 회원(단, NOL 카드 페이에 NOL 카드 등록 후 30일 이내 토핑 멤버십 1만원권 가입 필수/기존
          토핑 가입자도 동일)
          <br />
          *NOL 카드 페이는 NOL/트리플에서 제공하는 페이이며, 최초 약관 동의 시 자동으로 NOL 카드 페이 가입과 NOL 카드
          등록이 진행됨
        </li>
        <li>
          혜택 : NOL 카드 본인회원 기준 최초 1회 제공, NOL 카드 전용 toping 페이지에서 NOL 카드로 toping 멤버십 1만원
          결제 시, toping 가입비 1만원 지원 (NOL 카드 전용 toping 페이지에서 결제 시에만 혜택 적용되며, 주문서에서 1만원
          차감으로 반영)
        </li>
        <li>단, 이벤트 종료 후에도 위 이벤트 참가자에게 아래와 같은 조건으로 추가 혜택 제공</li>
        <li>NOL 티켓에서 제공하는 토핑 멤버십 상세 안내는 NOL 티켓에서 확인 가능</li>
      </ul>
    </NolNoticeBottomSheet>
  );
};

export default observer(TopingMemberShipBottomSheet);
